module.exports = __webpack_public_path__ + "static/media/lol.4b94d72f.jpg";